"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameBanner = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const settings_1 = require("../config/settings");
const brushpoint_svg_1 = __importDefault(require("../../assets/svg/brushpoint.svg"));
const gsap_core_1 = require("gsap/gsap-core");
class NameBanner extends Block_1.Block {
    constructor(app, txt, level = null, w = 100, h = w / 3) {
        super(app);
        this.w = w;
        this.h = h;
        this.overlayed = false;
        this.scorebox = new pixi_js_1.Container();
        this.bottomlayout = true;
        this.background = new pixi_js_1.Graphics();
        this._color = settings_1.Settings.lightLightGrayColor;
        this.alphaFilter = new pixi_js_1.AlphaFilter(1);
        this.overlay = new pixi_js_1.Graphics();
        this._hasscore = false;
        const style = Block_1.Block.textStyle(w / 5, (typeof txt === 'object' && (txt === null || txt === void 0 ? void 0 : txt.l)) ? txt : true);
        style.align = 'center';
        this.text = new pixi_js_1.Text(typeof txt === 'string' ? txt : txt === null || txt === void 0 ? void 0 : txt.u, style);
        this.text.anchor.set(0.5);
        this.addChild(this.background, this.overlay, this.text, this.scorebox);
        if (level) {
            this.sprite = pixi_js_1.Sprite.from(require('../../assets/levels/' + level.badge + '.svg').default);
            this.sprite.anchor.set(0.5);
            this.sprite.texture.baseTexture.resource.load().then(() => {
                this.layout();
            });
            this.addChild(this.sprite);
        }
        this.layout();
    }
    set score(score) {
        this._hasscore = true;
        this.scorebox.removeChildren();
        for (let i = 0; i < score; i++) {
            const brushScore = pixi_js_1.Sprite.from(brushpoint_svg_1.default);
            brushScore.scale.set((0, Global_1.px)(NameBanner.endscale));
            brushScore.position.set((i * (0, Global_1.px)(20)), 0);
            this.scorebox.addChild(brushScore);
        }
        this.layout();
    }
    set color(color) {
        this._color = color;
        this.layout();
    }
    inOverlay(color = settings_1.Settings.whiteColor, duration = 0.15) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.overlayed) {
                return;
            }
            this.overlayed = true;
            try {
                const box = this.mybox(color);
                const buffer = 0;
                const mask = (new pixi_js_1.Graphics())
                    .beginFill(0xffffff)
                    .drawRoundedRect((0, Global_1.px)(box.border + buffer), (0, Global_1.px)(box.border + buffer), (0, Global_1.px)(box.width - box.border * 2 - buffer * 2), (0, Global_1.px)(box.height - box.border * 2 - buffer * 2), (0, Global_1.px)(box.radius))
                    .endFill();
                mask.eventMode = 'none';
                this.overlay.mask = mask;
                this.overlay.addChild(mask);
                this.overlay.filters = [this.alphaFilter];
                this.makeBox(box, this.overlay);
                this.alphaFilter.alpha = 0.0;
                const tm = gsap_core_1.gsap.timeline()
                    .to(this.alphaFilter, {
                    alpha: 1,
                    duration: duration
                });
                if (color != settings_1.Settings.whiteColor) {
                    tm.to(this.text.style, {
                        fill: '#' + settings_1.Settings.whiteColor.toString(16),
                        duration: duration
                    }, '<');
                }
                yield this.promisedTimeline(tm);
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    mybox(color) {
        return {
            width: this.w,
            height: this.h,
            radius: this.w / 2,
            border: 2.3,
            borderColor: settings_1.Settings.grayColor,
            backgroundColor: color,
        };
    }
    layout() {
        var _a, _b, _c;
        super.layout();
        this.makeBox(this.mybox(this._color), this.background);
        const wi = (0, Global_1.px)(this.w / 2);
        const hi = (0, Global_1.px)(this.h / 2 + 1);
        this.text.position.set(wi, !this._hasscore ? hi : (this.text.height / 2 + (0, Global_1.px)(4)));
        const pad = this._hasscore ? 20 : 5;
        const fitratio = this.text.width / ((0, Global_1.px)(Math.max(this.w - pad, 0)) || this.text.width);
        if (fitratio > 1) {
            this.text.scale.x = 1 / fitratio;
        }
        (_a = this.sprite) === null || _a === void 0 ? void 0 : _a.scale.set((0, Global_1.px)(this.bottomlayout ? 0.13 : 0.15));
        if (!this.bottomlayout) {
            (_b = this.sprite) === null || _b === void 0 ? void 0 : _b.position.set((0, Global_1.isrtl)() ? (0, Global_1.px)(-10) : (0, Global_1.px)(this.w), (0, Global_1.px)(this.h / 2));
        }
        else {
            (_c = this.sprite) === null || _c === void 0 ? void 0 : _c.position.set((0, Global_1.px)(this.w / 2), (0, Global_1.px)(this.h + 3));
        }
        this.scorebox.pivot.set(this.scorebox.width / 2, 0);
        this.scorebox.position.set((0, Global_1.px)(this.w / 2), this.text.height + (0, Global_1.px)(7));
        this.pivot.set(wi, hi);
    }
    destroy(_options) {
        super.destroy(_options);
        this.alphaFilter.destroy();
    }
}
exports.NameBanner = NameBanner;
NameBanner.midscale = 0.333;
NameBanner.endscale = 0.222;
